import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {
  LoggedOutLayoutComponent,
  NoRoleLayoutComponent,
  StaffLayoutComponent,
} from '@asp/layouts';
import { PageNotFoundComponent } from '@asp/pages';
import { authGuard, roleGuard } from '@asp/authentication';

// TODO: FIX THIS SOMEHOW SO IT REDIRECTS TO LOGIN IF AN EXISTING PAGE HAS BEEN REQUESTED
const routes: Routes = [
  {
    path: '',
    component: LoggedOutLayoutComponent,
    loadChildren: () =>
      import('./views/pages/auth/auth.module').then((m) => m.AuthModule),
    canMatch: [authGuard(false)],
  },
  {
    path: '',
    component: StaffLayoutComponent,
    loadChildren: () =>
      import('./views/pages/staff/staff.module').then((m) => m.StaffModule),
    canMatch: [authGuard(true), roleGuard('Admins', 'Users')],
  },
  {
    path: '',
    component: NoRoleLayoutComponent,
    loadChildren: () =>
      import('./views/pages/no-role/no-role.module').then(
        (m) => m.NoRoleModule,
      ),
    canMatch: [authGuard(true)],
  },
  {
    path: '**',
    component: PageNotFoundComponent,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'top',
      onSameUrlNavigation: 'reload',
      anchorScrolling: 'enabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
